const reset_password_success = {
  title: '新しいパスワード設定',
  description:
  'パスワードは正常に再設定されました。 以下をクリックしてからログインしてください。',
  back: 'ログイン画面へ'
}
export default reset_password_success;
